// pages/Login.tsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, fetchVendorSettings, fetchVendorTaxSettings } from '../utils/api'; // Ensure these functions are defined in your api.js
import { useAuth } from '../context/AuthContext'; // Import the useAuth hook

const Login = () => {
    const { login: setAuth } = useAuth(); // Use the context login function

    const [username, setUsername] = useState(''); // Change setEmail to setUsername for clarity
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    // pages/Login.tsx


    const handleLogin = async () => {
        try {
            // Log in the user and get the response
            const response = await login(username, password);
            const userData = response.data;

            // Store token and user data in local storage
            setAuth(userData); // Update the auth state using context

            // console.log(userData);
            // Store token and user data in local storage
            localStorage.setItem('token', userData.token);
            localStorage.setItem('user', JSON.stringify(userData));

            // Fetch and store vendor settings
            // const settings = await fetchVendorSettings(userData.vendor_id);
            // localStorage.setItem('settings', JSON.stringify(settings));
            const settings = await fetchVendorSettings(userData.vendor_id);
            localStorage.setItem('settings', JSON.stringify([settings])); // Wrap in array if needed
            // console.log('login fetch', settings, JSON.stringify([settings]), settings);

            const taxsettings = await fetchVendorTaxSettings(userData.vendor_id);
            localStorage.setItem('taxsettings', JSON.stringify([taxsettings])); // Wrap in array if needed
            // console.log('login fetchtax ', taxsettings, JSON.stringify([taxsettings]));

            // Navigate to home after successful login
            navigate('/tables', { replace: true }); // Using replace to avoid going back to login on browser back button

        } catch (err: any) {
            // setLoading(false); // Set loading to true when login starts

            // Define a default error message
            let errorMessage = 'Login failed. Please check your credentials.';

            // Check if the error has a response and status
            if (err.response) {
                const status = err.response.status;

                // Map specific status codes to human-readable messages
                switch (status) {
                    case 401:
                        errorMessage = 'Unauthorized: Invalid username or password.';
                        break;
                    case 402:
                        errorMessage = 'Payment Required: Please contact support for assistance.';
                        break;
                    case 403:
                        errorMessage = 'Forbidden: You do not have permission to access this resource.';
                        break;
                    case 404:
                        errorMessage = 'Not Found: The server could not find the requested resource.';
                        break;
                    case 500:
                        errorMessage = 'Server Error: Something went wrong. Please try again later.';
                        break;
                    default:
                        errorMessage = `Error ${status}: ${err.response.statusText}`;
                        break;
                }
            } else if (err.message) {
                errorMessage = err.message;
            }

            setError(errorMessage);
        }
    };



    return (
        <div className="app-page">
            <div className="w-full min-h-screen flex flex-col justify-start mt-10 p-5">
                <div className="flex flex-col items-center">
                    <div><img
                        src={'../images/df.png'}
                        alt={'FreeGoPOS'}
                        crossOrigin="anonymous"
                        className='h-24 p-0 m-0'
                    /></div>
                <h1 className='pageTitle'>Login</h1>
                {error && <p className="text-red-500">{error}</p>}
                <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                        className="border p-2 m-2 w-full"
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                        className="border p-2 m-2 w-full"
                />
                {/* <p className="text-sm text-blue-500 cursor-pointer mt-4" onClick={() => navigate('/forgot-password')}>
                    Forgot your password?
                </p> */}
                    <button onClick={handleLogin} className="LogBtn p-2">
                    Login
                </button>
                </div>
            </div>
        </div>
    );
};

export default Login;